import { useProjectDataStore } from "@state/projectDataStore"
import React from "react"

type Props = {
  fontSize?: number
  children: React.ReactNode
  fontColour?: string
  brandingData: any
  onPointerEnter?: (event: React.PointerEvent<HTMLHeadingElement>) => void
  onPointerUp?: (event: React.PointerEvent<HTMLHeadingElement>) => void
  onPointerDown?: (event: React.PointerEvent<HTMLHeadingElement>) => void
}

const ListItem: React.FC<Props> = ({
  fontSize = 3.25,
  fontColour = "white",
  children,
  brandingData,
  onPointerEnter,
  ...props
}) => {
  const borderStyle = brandingData?.borderStyle || "rounded"

  const [isHovered, setIsHovered] = React.useState(false)

  const handlePointerEnter = (
    event: React.PointerEvent<HTMLHeadingElement>,
  ) => {
    setIsHovered(true)
    if (onPointerEnter) {
      onPointerEnter(event)
    }
  }

  const handlePointerLeave = () => {
    setIsHovered(false)
  }

  return (
    <h1
      {...props}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      style={{
        pointerEvents: "all",
        cursor: "pointer",
        transition: "opacity 0.3s",
        opacity: isHovered ? 0.5 : 1,
        fontSize: `${fontSize}rem`,
        fontWeight: "bold",
        color: fontColour,
        borderRadius: borderStyle === "rounded" ? "20px" : "0px",
      }}
    >
      {children}
    </h1>
  )
}

export default ListItem
